import React, { useState } from "react";
import DataTable from "react-data-table-component";
import {
  Badge,
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  Input,
} from "reactstrap";
import { MoreHorizontal, Edit, Trash2 } from "react-feather";
import Loader from "../../../../../CommonElements/Loader/loader";
import "./style.css"

const PUBLIC_BASE_URL = process.env.REACT_APP_FILE_BASE_URL || process.env.REACT_APP_BASE_URL || "http://localhost:4001";

const BannerTable = ({
  banners,
  loading,
  onEdit,
  onDelete,
  onDeActivate,
  totalRows,
  perPage,
  currentPage,
  onPageChange,
  onRowsPerPageChange,
}) => {
  const [dropdownOpen, setDropdownOpen] = useState(null);
  const toggleDropdown = (id) => setDropdownOpen(dropdownOpen === id ? null : id);

  const columns = [
    {
      name: "Image",
      cell: (row) => (
        <img
          src={`${PUBLIC_BASE_URL}/${row.image}`}
          alt={row.title}
          style={{
            width: "50px",
            height: "50px",
            objectFit: "cover",
            borderRadius: "4px",
            border: "1px solid #e5e7eb",
          }}
        />
      ),
      width: "80px",
      center: true,
    },
    {
      name: "Banner Name",
      selector: (row) => row.title,
      sortable: true,
      cell: (row) => (
        <div style={{ padding: "10px 0", fontWeight: "500" }}>{row.title}</div>
      ),
    },
    {
      name: "Arabic Name",
      selector: (row) => row.titleAr,
      sortable: true,
      cell: (row) => (
        <div style={{ padding: "10px 0", fontWeight: "500" }}>{row.titleAr || "N/A"}</div>
      ),
    },
    {
      name: "Type",
      selector: (row) => row.bannerType,
      sortable: true,
      cell: (row) => (
        <div style={{ padding: "10px 0", textTransform: "capitalize" }}>
          {row.bannerType || "N/A"}
        </div>
      ),
    },
    {
      name: "Status",
      selector: (row) => row.status,
      sortable: true,
      cell: (row) => (
        <Badge
          color={
            row.status === "approved"
              ? "success"
              : row.status === "pending"
                ? "warning"
                : row.status === "declined"
                  ? "danger"
                  : row.status === "deactivated"
                    ? "secondary"
                    : "light"
          }
          pill
          style={{ padding: "6px 12px", fontSize: "12px", fontWeight: "600" }}
        >
          <span style={{ textTransform: "capitalize" }}>{row.status}</span>
        </Badge>
      ),
    },
    {
      name: "Views",
      selector: (row) => row.views,
      sortable: true,
      cell: (row) => (
        <div style={{ padding: "10px 0" }}>{row.views?.toLocaleString() || "0"}</div>
      ),
    },
    {
      name: "Clicks",
      selector: (row) => row.clicks,
      sortable: true,
      cell: (row) => (
        <div style={{ padding: "10px 0" }}>{row.clicks?.toLocaleString() || "0"}</div>
      ),
    },
    {
      name: "Activate/Deactivate",
      cell: (row) => (
        <label className="switch">
          <input
            type="checkbox"
            checked={row.status === "approved"}
            onChange={() => onDeActivate(row._id)}
            // disabled={row.status === "pending" || row.status === "declined"}
            style={{ cursor: row.status === "pending" || row.status === "declined" ? "not-allowed" : "pointer" }}
            title={row.status === "approved" ? "Deactivate" : "Activate"}
          />
          <span className="slider round"></span>
        </label>
      ),
    },
    {
      name: "Actions",
      cell: (row) => (
        <Dropdown
          isOpen={dropdownOpen === row._id}
          toggle={() => toggleDropdown(row._id)}
        >
          <DropdownToggle
            color="light"
            size="sm"
            className="border-0 shadow-none rounded-circle"
            style={{ padding: "5px" }}
          >
            <MoreHorizontal size={18} />
          </DropdownToggle>
          <DropdownMenu
            end
            style={{
              position: "absolute",
              zIndex: 1000,
              boxShadow: "0 2px 10px rgba(0,0,0,0.1)",
              borderRadius: "4px",
            }}
          >
            <DropdownItem
              onClick={() => onEdit(row)}
              className="d-flex align-items-center px-3 py-2"
              style={{ fontSize: "14px", color: "#333", cursor: "pointer" }}
            >
              <Edit size={14} className="me-2" /> Edit
            </DropdownItem>
            <DropdownItem
              onClick={() => onDelete(row._id)}
              className="d-flex align-items-center px-3 py-2 text-danger"
              style={{ fontSize: "14px", cursor: "pointer" }}
            >
              <Trash2 size={14} className="me-2" /> Delete
            </DropdownItem>
          </DropdownMenu>
        </Dropdown>
      ),
      ignoreRowClick: true,
      allowOverflow: true,
      button: true,
      width: "100px",
      center: true,
    },
  ];

  const customStyles = {
    table: {
      style: {
        border: "1px solid #e5e7eb",
        borderRadius: "8px",
        overflow: "hidden",
        backgroundColor: "#fff",
      },
    },
    headCells: {
      style: {
        backgroundColor: "#343a40",
        color: "white",
        fontWeight: "600",
        fontSize: "14px",
        padding: "12px",
        borderBottom: "1px solid #dee2e6",
      },
    },
    cells: {
      style: {
        padding: "12px",
        fontSize: "14px",
        color: "#333",
      },
    },
    rows: {
      style: {
        "&:hover": {
          backgroundColor: "#f1f5f9",
        },
      },
      stripedStyle: {
        backgroundColor: "#f9fafb",
      },
    },
    pagination: {
      style: {
        borderTop: "1px solid #e5e7eb",
        padding: "10px",
        backgroundColor: "#fff",
      },
    },
  };

  return loading ? (
    <Loader />
  ) : (
    <div className="table-responsive">
      <DataTable
        columns={columns}
        data={banners}
        pagination
        paginationServer
        paginationTotalRows={totalRows}
        paginationDefaultPage={currentPage}
        paginationPerPage={perPage}
        onChangeRowsPerPage={onRowsPerPageChange}
        onChangePage={onPageChange}
        customStyles={customStyles}
        highlightOnHover
        striped
        responsive
        noDataComponent={
          <div style={{ padding: "20px", textAlign: "center", color: "#6b7280" }}>
            No banners available
          </div>
        }
      />
    </div>
  );
};

export default BannerTable;